// Meta (Facebook/Instagram) Pixel loader — no-op until REACT_APP_META_PIXEL_ID is set.
export const initMetaPixel = () => {
  const id = (process.env.REACT_APP_META_PIXEL_ID || '').trim();
  if (!id || window.fbq) return;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
    n.queue = []; t = b.createElement(e); t.async = !0; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', id);
  window.fbq('track', 'PageView');
};

// Map internal analytics events to Meta standard events
const META_EVENTS = {
  product_view: (extra) => ['ViewContent', { content_ids: [String(extra.product_id)], content_type: 'product' }],
  add_to_cart: (extra) => ['AddToCart', { content_ids: [String(extra.product_id)], content_type: 'product' }],
  checkout_start: () => ['InitiateCheckout', {}],
  purchase: (extra) => ['Purchase', { value: extra.value || 0, currency: 'MXN' }],
};

export const metaTrack = (event, extra = {}) => {
  try {
    if (!window.fbq) return;
    const mapped = META_EVENTS[event];
    if (mapped) {
      const [name, params] = mapped(extra);
      window.fbq('track', name, params);
    }
  } catch (e) {
    if (process.env.NODE_ENV === 'development') console.debug('meta pixel track failed:', e);
  }
};
